<p-modal [open]="open" (dismiss)="close()">
  <p-heading slot="header" [size]="'large'" [tag]="'h2'">
    Edit {{ user?.firstName }} {{ user?.lastName }}
  </p-heading>

  <ng-container *ngrxLet="data$ as data; error as dataError; suspenseTpl: spinner">
    @if (dataError) {
      <opa-reload-button [label]="'Reload Edit Member'" (click)="reloadData()" />
    } @else if (data) {
      <form class="form" [formGroup]="form" [id]="formId" (ngSubmit)="submit()">
        <p-text-field-wrapper
          *ngrxLet="form.controls.firstName as control"
          [label]="'First Name'"
          [message]="control.errors?.['message'] ?? ''"
          [state]="control.touched && control.errors ? 'error' : 'none'"
        >
          <input type="text" [attr.required]="true" [formControl]="control" />
        </p-text-field-wrapper>

        <p-text-field-wrapper
          *ngrxLet="form.controls.lastName as control"
          [label]="'Last Name'"
          [message]="control.errors?.['message'] ?? ''"
          [state]="control.touched && control.errors ? 'error' : 'none'"
        >
          <input type="text" [attr.required]="true" [formControl]="control" />
        </p-text-field-wrapper>

        <div class="switch-control">
          <p-text>User Status</p-text>
          <p-switch
            *ngrxLet="form.controls.active as control"
            [checked]="control.value ?? undefined"
            [disabled]="control.disabled"
            (update)="control.patchValue($event.detail.checked)"
          >
            Active
          </p-switch>
        </div>

        <p-select-wrapper
          *ngrxLet="form.controls.position as control"
          [filter]="true"
          [label]="'Position'"
          [message]="control.errors?.['message'] ?? ''"
          [state]="control.touched && control.errors ? 'error' : 'none'"
        >
          <select [attr.required]="true" [formControl]="control">
            <option
              *ngFor="let position of data.positions; trackBy: trackPosition"
              [value]="position.id"
            >
              {{ position.description }}
            </option>
          </select>
        </p-select-wrapper>

        <div class="checkbox-control">
          <p-text>Increase Fun & Games Budget</p-text>
          <p-checkbox-wrapper
            *ngrxLet="form.controls.doubleMonthlyBudget as control"
            [label]="'Add additional €20 per month'"
            [message]="control.errors?.['message'] ?? ''"
            [state]="control.touched && control.errors ? 'error' : 'none'"
          >
            <input type="checkbox" [formControl]="control" />
          </p-checkbox-wrapper>
        </div>

        <div class="checkbox-control">
          <p-text>Remote Employee</p-text>
          <p-checkbox-wrapper
            *ngrxLet="form.controls.remoteEmployee as control"
            [label]="'Remote Employee'"
            [message]="control.errors?.['message'] ?? ''"
            [state]="control.touched && control.errors ? 'error' : 'none'"
          >
            <input type="checkbox" [formControl]="control" />
          </p-checkbox-wrapper>
        </div>

        <ng-container *ngIf="form.controls.remoteEmployee.value">
          <p-select-wrapper
            *ngrxLet="form.controls.remoteLocationId as control"
            [filter]="true"
            [label]="'Remote Location'"
            [message]="control.errors?.['message'] ?? ''"
            [state]="control.touched && control.errors ? 'error' : 'none'"
          >
            <select [attr.required]="true" [formControl]="control">
              <option
                *ngFor="let location of data.locations; trackBy: trackLocation"
                [value]="location.id"
              >
                {{ location.description }}
              </option>
            </select>
          </p-select-wrapper>
        </ng-container>
      </form>

      <p-button-group slot="footer">
        <p-button [form]="formId" [loading]="data.submitting" [type]="'submit'">Save</p-button>
        <p-button [iconSource]="'assets/icons/close.svg'" [variant]="'secondary'" (click)="close()">
          Close
        </p-button>
      </p-button-group>
    }
  </ng-container>
</p-modal>

<ng-template #spinner>
  <opa-spinner />
</ng-template>
